import { Skeleton } from "@/components/atoms";
import { useUIColors } from "@/core/hooks";
import { PropertiesLayout } from "@/modules/home/hooks/usePropertiesLayout";
import React from "react";
import { StyleSheet, View } from "react-native";

export interface PropertyListingCardSkeletonProps {
  layout?: PropertiesLayout;
}

/** Skeleton for PropertyListingCard — mirrors its exact structure/dimensions. */
export function PropertyListingCardSkeleton({ layout = "grid" }: Readonly<PropertyListingCardSkeletonProps>) {
  const c = useUIColors();

  const statsRow = (
    <View style={styles.statsRow}>
      <Skeleton width={40} height={14} />
      <Skeleton width={40} height={14} />
      <Skeleton width={40} height={14} />
    </View>
  );

  const priceBadge = <Skeleton width="100%" height={40} borderRadius={8} />;

  if (layout === "list") {
    return (
      <View
        style={[
          styles.listContainer,
          { backgroundColor: c.backgroundLevel1, borderColor: c.backgroundLevel2 },
        ]}
      >
        <View style={styles.listTopRow}>
          <Skeleton width={107} height={75} borderRadius={8} />
          <View style={styles.listContent}>
            <Skeleton width={180} height={16} />
            {statsRow}
          </View>
        </View>
        {priceBadge}
      </View>
    );
  }

  return (
    <View
      style={[
        styles.container,
        { backgroundColor: c.backgroundLevel1, borderColor: c.backgroundLevel2 },
      ]}
    >
      <Skeleton width="100%" height={200} borderRadius={8} />
      <View style={styles.content}>
        <Skeleton width={180} height={16} />
        {statsRow}
        {priceBadge}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    borderRadius: 12,
    padding: 8,
    gap: 8,
    borderWidth: 1,
  },
  content: {
    gap: 8,
    marginTop: 12,
  },
  listContainer: {
    borderRadius: 12,
    padding: 12,
    gap: 12,
    borderWidth: 1,
  },
  listTopRow: {
    flexDirection: "row",
    gap: 12,
  },
  listContent: {
    flex: 1,
    gap: 8,
    justifyContent: "center",
  },
  statsRow: {
    flexDirection: "row",
    gap: 16,
  },
});

export default PropertyListingCardSkeleton;
